module.exports = __webpack_public_path__ + "static/media/mefaLogojpg.9a23aab4.jpg";